import Button from "cms/components/Button";
import { ButtonVariant } from "cms/components/Button/Button.styles";
import OptimizedImage from "cms/components/OptimizedImage";
import Text from "cms/components/Text";
import BlueBackground from "cms/images/blue-background.webp";
import UizardLogo from "cms/images/uizard-logo-white-big.svg";
import { graphql } from "gatsby";
import React from "react";

import {
  Container,
  Content,
  Divider,
  HeadlineContainer,
  Link,
  Logo,
  LogoWrapper,
  LogosContainer,
  MessageContainer,
} from "./MordorCaseStudyBlock.styles";

export interface MordorCaseStudyBlockProps
  extends Queries.SanityMordorCaseStudyBlock {}

const MordorCaseStudyBlock: React.FC<MordorCaseStudyBlockProps> = ({
  headline,
  button,
  logoImage,
  logoImageAlt,
}) => (
  <Container>
    <Content>
      <MessageContainer>
        <HeadlineContainer>
          <Text variant="D3" as="h3" weight="medium">
            {headline}
          </Text>
        </HeadlineContainer>
        {button?.url && button?.label && (
          <Link href={button.url}>
            <Button
              label={button.label}
              variant={button.variant as ButtonVariant}
            />
          </Link>
        )}
      </MessageContainer>

      <LogosContainer $background={BlueBackground}>
        <LogoWrapper>
          <Logo src={UizardLogo} alt="Uizard logo" />
        </LogoWrapper>

        <Divider />

        {logoImage && (
          <LogoWrapper>
            <OptimizedImage image={logoImage} alt={logoImageAlt} />
          </LogoWrapper>
        )}
      </LogosContainer>
    </Content>
  </Container>
);

export const query = graphql`
  fragment MordorCaseStudyBlock on SanityMordorCaseStudyBlock {
    _key
    _type
    headline
    button {
      variant
      label
      url
    }
    logoImage { ...OptimizedImage }
    logoImageAlt
  }
`;

export default MordorCaseStudyBlock;
